import _regeneratorRuntime from 'babel-runtime/regenerator';
var _this = this;
function _asyncToGenerator(fn) {
  return function () {
    var gen = fn.apply(this, arguments);
    return new Promise(function (resolve, reject) {
      function step(key, arg) {
        try {
          var info = gen[key](arg);
          var value = info.value;
        } catch (error) {
          reject(error);
          return;
        }
        if (info.done) {
          resolve(value);
        } else {
          return Promise.resolve(value).then(function (value) {
            step("next", value);
          }, function (err) {
            step("throw", err);
          });
        }
      }
      return step("next");
    });
  };
}
import { callAPI } from './apiActions';
import config from '../../config';
import { getLevel1Data, subscribeToLevel1, getAllLevel1Data, unsubscribeLevel1 } from './level1Actions';
import { getLevel2Data, subscribeToLevel2, unsubscribeLevel2 } from './level2Actions';
import { getRecentTrades, subscribeToRecentTrades, unsubscribeRecentTrades } from './recentTradesActions';
import filterSortSupportedInstruments from '../../helpers/filterSortSupportedInstruments';
import { setMarginInstrument } from '../actions/marginActions';
import { fetchTickers, subscribeToTickers, unsubscribeTicker } from './tickersActions';
export var fetchInstruments = function fetchInstruments() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(dispatch, getState) {
      var selectedInstrumentId, instruments, filteredInstruments, instrumentId, store;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              selectedInstrumentId = options.selectedInstrumentId;
              _context.prev = 1;
              dispatch(requestInstruments());
              _context.next = 5;
              return dispatch(callAPI('GetInstruments', {
                OMSId: 1
              }));
            case 5:
              instruments = _context.sent;
              filteredInstruments = filterSortSupportedInstruments(instruments);
              dispatch(receiveInstruments(filteredInstruments));
              if (filteredInstruments.length) {
                _context.next = 10;
                break;
              }
              return _context.abrupt('return');
            case 10:
              instrumentId = filteredInstruments.some(function (i) {
                return i.InstrumentId === selectedInstrumentId;
              }) ? selectedInstrumentId : filteredInstruments[0].InstrumentId;
              dispatch(setInstrument(instrumentId));
              store = getState();
              if (store.apexCore.level2.fetching) {
                dispatch(getLevel2Data(instrumentId));
                dispatch(subscribeToLevel2());
              }
              if (!config.global.privateMarketData) {
                dispatch(getLevel1Data(instrumentId));
                if (Object.keys(store.apexCore.level1).length == 0) {
                  dispatch(getAllLevel1Data(filteredInstruments));
                }
                dispatch(subscribeToLevel1(selectedInstrumentId));
                if (store.recentTrades.fetching) {
                  dispatch(getRecentTrades(instrumentId));
                  dispatch(subscribeToRecentTrades());
                }
                dispatch(fetchTickers());
                dispatch(subscribeToTickers());
              }
              _context.next = 20;
              break;
            case 17:
              _context.prev = 17;
              _context.t0 = _context['catch'](1);
              console.error(_context.t0);
            case 20:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this, [[1, 17]]);
    }));
    return function (_x2, _x3) {
      return _ref.apply(this, arguments);
    };
  }();
};
export var SELECT_INSTRUMENT = 'SELECT_INSTRUMENT';
export var selectInstrument = function selectInstrument(instrumentId) {
  return function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(dispatch, getState) {
      var selectedInstrumentId, tradingStyleFormObj;
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              selectedInstrumentId = getState().apexCore.instrument.selectedInstrumentId;
              tradingStyleFormObj = getState().form.tradingStyle;
              if (tradingStyleFormObj) {
                dispatch(setMarginInstrument(instrumentId));
                dispatch(setInstrument(instrumentId));
              } else {
                dispatch(setInstrument(instrumentId));
              }
              localStorage.setItem('selectedInstrumentId', instrumentId);
              dispatch(unsubscribeLevel1(selectedInstrumentId));
              dispatch(getLevel1Data(instrumentId));

              // resubscribe to level2
              dispatch(subscribeToLevel1(instrumentId));
              dispatch(unsubscribeLevel2(selectedInstrumentId));
              dispatch(getLevel2Data(instrumentId));
              if (!config.global.privateMarketData) {
                // resubscribe to trades
                dispatch(unsubscribeRecentTrades(selectedInstrumentId));
                dispatch(getRecentTrades(instrumentId));
                dispatch(subscribeToRecentTrades());
                dispatch(unsubscribeTicker(selectedInstrumentId)).then(function () {
                  dispatch(fetchTickers());
                  dispatch(subscribeToTickers());
                });
              }
            case 10:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, _this);
    }));
    return function (_x4, _x5) {
      return _ref2.apply(this, arguments);
    };
  }();
};
export var SET_INSTRUMENT = 'SET_INSTRUMENT';
export var setInstrument = function setInstrument(instrumentId) {
  return {
    type: SET_INSTRUMENT,
    payload: instrumentId
  };
};
export var REQUEST_INSTRUMENTS = 'REQUEST_INSTRUMENTS';
export var requestInstruments = function requestInstruments() {
  return {
    type: REQUEST_INSTRUMENTS,
    payload: ''
  };
};
export var RECEIVE_INSTRUMENTS = 'RECEIVE_INSTRUMENTS';
export var receiveInstruments = function receiveInstruments(instruments) {
  return {
    type: RECEIVE_INSTRUMENTS,
    payload: instruments
  };
};